export enum BreadcrumbsIconsEnum {
    Region = 'assets/img/mdi_planet.svg',
    State = 'assets/img/state.svg',
    Subdivision = 'assets/img/fluent_arrow-split-16-filled.svg',
    TypeOfStucture = 'assets/img/bi_houses.svg',
    Address = 'assets/img/bi_house.svg',
}

export enum UIIconsEnum {
    Show = 'assets/img/show_icon.svg',
    Hide = 'assets/img/hide_icon.svg',
    Excel = 'assets/img/excel_icon.svg',
    Pdf = 'assets/img/pdf_icon.svg',
    View3D = 'assets/img/3d-view_icon.svg',
    RightArrow = 'assets/img/iconoir_arrow-right.svg',
    LeftArrow = 'assets/img/iconoir_arrow-left.svg',
    Upload = 'assets/img/upload.svg',
    Delete = 'assets/img/trash-04.svg',
    Cancel = 'assets/img/x-02.svg',
    Ready = 'assets/img/ready.svg',
    File = 'assets/img/file.svg',
}

